import { render } from "./AdTypeSelector.vue?vue&type=template&id=39c668f4"
import script from "./AdTypeSelector.vue?vue&type=script&lang=js"
export * from "./AdTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__